module.exports = __webpack_public_path__ + "static/media/TW.b5c9943f.svg";